<template>
  <div class="raporlar-view">
    <AppMain>
      <div class="container">
        <div class="page-title-container mb-4">
          <div class="row">
            <div class="col-12 col-md-8">
              <h1 class="mb-0 pb-0 display-5">Raporlar</h1>
              <nav class="breadcrumb-container d-inline-block" aria-label="breadcrumb">
                <ul class="breadcrumb pt-0">
                  <li class="breadcrumb-item">
                    <router-link to="/">Anasayfa</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link to="/raporlar">Raporlar</router-link>
                  </li>
                </ul>
              </nav>
            </div>
            <div class="col-12 col-md-4 d-flex align-items-start justify-content-md-end mt-2 mt-md-0">
              <button class="btn btn-outline-primary" @click="raporGetir" :disabled="yukleniyor">
                {{ yukleniyor ? "Yükleniyor..." : "Raporu Yenile" }}
              </button>
            </div>
          </div>
        </div>

        <div class="card mb-4 border-0 shadow-sm">
          <div class="card-body">
            <div class="row g-3 align-items-end">
              <div class="col-12 col-md-3">
                <label class="form-label text-muted text-small">Rapor Tipi</label>
                <select class="form-select" v-model="filtre.raporTipi">
                  <option value="ucay">Son 3 Aylık</option>
                  <option value="altiay">Son 6 Aylık</option>
                  <option value="yillik">Yıllık</option>
                  <option value="ozel">Özel Tarih Aralığı</option>
                </select>
              </div>

              <template v-if="filtre.raporTipi === 'ozel'">
                <div class="col-6 col-md-3">
                  <label class="form-label text-muted text-small">Başlangıç</label>
                  <input type="date" class="form-control" v-model="filtre.baslangic" />
                </div>
                <div class="col-6 col-md-3">
                  <label class="form-label text-muted text-small">Bitiş</label>
                  <input type="date" class="form-control" v-model="filtre.bitis" />
                </div>
              </template>

              <div class="col-12 col-md-2 d-grid">
                <button class="btn btn-primary" @click="raporGetir" :disabled="yukleniyor">
                  Uygula
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row g-3 mb-4">
          <div class="col-12 col-sm-6 col-xl-3" v-for="kpi in kpiKartlari" :key="kpi.baslik">
            <div class="card h-100 border-0 shadow-sm kpi-card">
              <div class="card-body">
                <div class="text-muted text-small mb-1">{{ kpi.baslik }}</div>
                <div class="display-6 fw-bold mb-1">{{ kpi.deger }}</div>
                <div class="text-small" :class="kpi.vurguClass">{{ kpi.aciklama }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="row g-4">
          <div class="col-12 col-xxl-7">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-header border-0 pb-0">
                <h2 class="small-title mb-0">Çalışan Performans Özeti (Çalışma Yüklemesi)</h2>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table table-hover align-middle mb-0">
                    <thead>
                      <tr>
                        <th>Çalışan</th>
                        <th>Çalışma Yükleme</th>
                        <th>Revize/Çalışma</th>
                        <th>En Çok Müşteri</th>
                        <th>Ajans Ort.</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="calisan in rapor.calisanlar" :key="calisan.kullaniciId">
                        <td>
                          <div class="fw-semibold">{{ calisan.ad }}</div>
                          <div class="text-muted text-small">
                            Dallar: {{ ilkUcDal(calisan.dalDagilimi) }}
                          </div>
                        </td>
                        <td>
                          <span class="fw-semibold">{{ calisan.toplamCalisma ?? calisan.toplamIs }}</span>
                        </td>
                        <td>
                          <span class="badge bg-outline-primary">%{{ calisan.revizeOrani }}</span>
                        </td>
                        <td>
                          <div>{{ calisan.enCokCalistigiMusteri }}</div>
                          <div class="text-muted text-small">
                            {{ calisan.enCokCalistigiMusteriAdet }} çalışma
                          </div>
                        </td>
                        <td style="min-width: 180px">
                          <div class="d-flex justify-content-between text-small mb-1">
                            <span>{{ calisan.performansEtiketi }}</span>
                            <span>%{{ calisan.ajansOrtalamasiDurumu }}</span>
                          </div>
                          <div class="progress sh-1">
                            <div
                              class="progress-bar"
                              :class="performansBarClass(calisan.ajansOrtalamasiDurumu)"
                              role="progressbar"
                              :style="{ width: progressWidth(calisan.ajansOrtalamasiDurumu) }"
                            ></div>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="!rapor.calisanlar.length">
                        <td colspan="5" class="text-center text-muted py-4">
                          Seçilen aralıkta çalışan verisi bulunamadı.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-xxl-5">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-header border-0 pb-0">
                <h2 class="small-title mb-0">Müşteri Bazlı Dönem Durumu</h2>
              </div>
              <div class="card-body">
                <div v-if="rapor.musteriler.length" class="d-flex flex-column gap-3">
                  <div class="border rounded-3 p-3" v-for="musteri in rapor.musteriler" :key="musteri.musteriId || musteri.musteri">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="fw-semibold">{{ musteri.musteri }}</div>
                      <span class="badge bg-outline-primary">{{ musteri.toplamCalisma ?? 0 }} çalışma</span>
                    </div>
                    <div class="row mt-2 text-small">
                      <div class="col-6 text-muted">Tamamlanan</div>
                      <div class="col-6 text-end">{{ musteri.tamamlananIs }}</div>
                      <div class="col-6 text-muted">Toplam Revize</div>
                      <div class="col-6 text-end">{{ musteri.revizeSayisi }}</div>
                      <div class="col-6 text-muted">Musteri Revize</div>
                      <div class="col-6 text-end">{{ musteri.musteriRevizeSayisi }}</div>
                      <div class="col-6 text-muted">Revize Orani</div>
                      <div class="col-6 text-end">%{{ musteri.revizeOrani }}</div>
                    </div>
                  </div>
                </div>
                <div v-else class="text-center text-muted py-4">
                  Seçilen aralıkta müşteri raporu bulunamadı.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppMain>
  </div>
</template>

<script>
import axiosCustom from "@/services/axiosCustom";
import AppMain from "@/components/AppMain.vue";

export default {
  name: "RaporlarView",
  components: {
    AppMain,
  },
  data() {
    const bugun = new Date().toISOString().split("T")[0];
    return {
      yukleniyor: false,
      filtre: {
        raporTipi: "ucay",
        baslangic: bugun,
        bitis: bugun,
      },
      rapor: {
        genel: {
          toplamCalisma: 0,
          toplamIs: 0,
          tamamlananIs: 0,
          aktifIs: 0,
          toplamRevize: 0,
          musteriRevize: 0,
          calisanSayisi: 0,
          musteriSayisi: 0,
          ajansCalismaOrtalama: 0,
          ajansTamamlananOrtalama: 0,
        },
        calisanlar: [],
        musteriler: [],
      },
    };
  },
  computed: {
    kpiKartlari() {
      return [
        {
          baslik: "Toplam Çalışma Yüklemesi",
          deger: this.rapor.genel.toplamCalisma ?? 0,
          aciklama: `Dönemde ${this.rapor.genel.toplamIs} iş kaydı var`,
          vurguClass: "text-success",
        },
        {
          baslik: "Toplam Revize",
          deger: this.rapor.genel.toplamRevize,
          aciklama: `${this.rapor.genel.musteriRevize} tanesi müşteri kaynaklı`,
          vurguClass: "text-warning",
        },
        {
          baslik: "Çalışan Sayısı",
          deger: this.rapor.genel.calisanSayisi,
          aciklama: `Ajans ort. çalışma: ${this.rapor.genel.ajansCalismaOrtalama ?? this.rapor.genel.ajansTamamlananOrtalama}`,
          vurguClass: "text-primary",
        },
        {
          baslik: "Müşteri Sayısı",
          deger: this.rapor.genel.musteriSayisi,
          aciklama: `${this.rapor.genel.aktifIs} aktif iş var`,
          vurguClass: "text-info",
        },
      ];
    },
  },
  mounted() {
    this.raporGetir();
  },
  methods: {
    async raporGetir() {
      if (this.filtre.raporTipi === "ozel" && (!this.filtre.baslangic || !this.filtre.bitis)) {
        this.$toast.error("Özel rapor için başlangıç ve bitiş tarihi seçiniz.");
        return;
      }

      this.yukleniyor = true;
      try {
        const params = {
          raporTipi: this.filtre.raporTipi,
          baslangic: this.filtre.baslangic,
          bitis: this.filtre.bitis,
        };
        const response = await axiosCustom.get("raporlar/ozet", { params });
        this.rapor = response.data || this.rapor;
      } catch (error) {
        console.error("Rapor veri çekme hatası: ", error);
        this.$toast.error("Rapor verileri alınamadı.");
      } finally {
        this.yukleniyor = false;
      }
    },
    ilkUcDal(dalDagilimi) {
      if (!dalDagilimi || typeof dalDagilimi !== "object") {
        return "-";
      }
      const dallar = Object.keys(dalDagilimi);
      if (!dallar.length) {
        return "-";
      }
      return dallar.slice(0, 3).join(", ");
    },
    performansBarClass(oran) {
      if (oran >= 120) return "bg-success";
      if (oran >= 90) return "bg-primary";
      return "bg-warning";
    },
    progressWidth(oran) {
      const sinirli = Math.max(0, Math.min(Number(oran) || 0, 180));
      return `${(sinirli / 180) * 100}%`;
    },
  },
};
</script>

<style scoped>
.kpi-card {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95), rgba(247, 248, 255, 0.95));
}

.small-title {
  font-weight: 600;
}

.table > :not(caption) > * > * {
  vertical-align: middle;
}
</style>
